export default __webpack_public_path__ + "static/media/044-departure.dd8527e6.svg";